import { render, staticRenderFns } from "./studentFile.vue?vue&type=template&id=50b92fe0"
import script from "./studentFile.vue?vue&type=script&lang=js"
export * from "./studentFile.vue?vue&type=script&lang=js"
import style0 from "./studentFile.vue?vue&type=style&index=0&id=50b92fe0&prod&lang=less&scope=true"
import style1 from "./studentFile.vue?vue&type=style&index=1&id=50b92fe0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports